// extracted by mini-css-extract-plugin
export default {"wrapper":"dcc_infoI-wrapper","wrapperForced":"dcc_infoI-wrapperForced"};